<div class="link-box">
  <h3>لینک‌های مفید</h3>
  <ul>
    <li *ngFor="let link of links">
      <a [href]="link.url" target="_blank">{{ link.label }}</a>
    </li>
  </ul>
</div>
